import { render, staticRenderFns } from "./BusItemImageEdit.vue?vue&type=template&id=1014a1fe&scoped=true&"
import script from "./BusItemImageEdit.vue?vue&type=script&lang=js&"
export * from "./BusItemImageEdit.vue?vue&type=script&lang=js&"
import style0 from "./BusItemImageEdit.vue?vue&type=style&index=0&id=1014a1fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1014a1fe",
  null
  
)

export default component.exports